import { render } from "./MemberTwitter.vue?vue&type=template&id=11df6413"
import script from "./MemberTwitter.vue?vue&type=script&lang=js"
export * from "./MemberTwitter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__